// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// Export the factory function instead of a class to prevent initialization order problems

import type { Subscription } from "le-coffre-resources/dist/Admin";
import type { QueryPayload, RequestOptions } from "../../../types";

// Export types
export type IPostSubscriptionsParams = {
	[key: string]: unknown;
	emails: string[];
};

export type IPutSubscriptionsParams = {
	[key: string]: unknown;
	assigned_user_uids?: string[];
	nb_seats?: number;
};

// Export a compatible interface for backwards compatibility
export interface ISubscriptions {
	get(q?: QueryPayload, options?: RequestOptions): Promise<Subscription[]>;
	post(body: IPostSubscriptionsParams): Promise<unknown>;
	put(uid: string, body: IPutSubscriptionsParams): Promise<unknown>;
	cancelAtPeriodEnd(uid: string): Promise<Subscription>;
	reactivateAtPeriodEnd(uid: string): Promise<Subscription>;
}

import { getLazyFactoryGetter } from "@Front/Api/helpers/dynamicFactoryLoader";

function getFactory(): () => ISubscriptions {
	return getLazyFactoryGetter("LeCoffreApi/Admin/Subscriptions") as () => ISubscriptions;
}

// Export the instance getter as the main export
export const Subscriptions = {
	getInstance: (): ISubscriptions => {
		return getFactory()();
	},
};

// Export default for backward compatibility with existing imports
export default Subscriptions;
